import $ from "jquery";
import "slicknav/jquery.slicknav";
import MenuSlug from "./menu-slug";

$(document).ready(function () {
  // Mobile menu
  $("#page-header-nav").slicknav({
    "prependTo": "#page-header-mobile-nav",
    "label": "",
    "closedSymbol": "<span class=\"slicknav-closed-btn\">+</span>",
    "openedSymbol": "<span class=\"slicknav-open-btn\">&ndash;</span>",
    "allowParentLinks": true
  });

  const hamburger = $(".hamburger");
  const slicknavButton = $("a.slicknav_btn");
  hamburger.on("click", function () {
    hamburger.toggleClass("is-active");
    slicknavButton.trigger("click");
  });

  // Set the current menu item
  const currentPage = window.location.pathname.substring(window.location.pathname.lastIndexOf("/"));
  var currentMenuItem = (currentPage && currentPage.length > 1)
    ? $(`nav a[href="${currentPage}"]`)
    : $(`nav a[href="/index.php"], nav a[href="/"]`);
  currentMenuItem.addClass("current");

  // Look for a parent menu item to set as current as well
  currentMenuItem
    .closest("ul")
    .parent("li")
    .children("a")
    .addClass("current");

  var menuSlug = new MenuSlug();
  menuSlug.run();
});



// WEBPACK FOOTER //
// ./header/windsorpc-header.js